import styled from '@emotion/styled';
import React from 'react';

const Header3 = ({ title, color }) => {
  return (
    <HeaderWrapper>
      <StyledHeader3 titleColor={color}>{title}</StyledHeader3>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  position: relative;
  margin-bottom: 25px;
`;

const StyledHeader3 = styled.h3`
  width: auto;
  color: ${(props) => props.titleColor};
  font-family: Anton;
  font-size: 25px;
  letter-spacing: 1px;
  line-height: 33px;
  z-index: 2;

  &::before {
    position: absolute;
    width: 50px;
    content: ' ';
    border: 4px solid #00c2ba;
    background-color: #00c2ba;
    border-radius: 4px;
    top: -20px;
    z-index: inherit;
  }
`;

export default Header3;
